@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

<ng-template #text let-row="data" let-field="field" let-override="override" let-template="template">
    <div class="ws-flex-grow">
        <input type="text"
               autocomplete="off"
               class="form-control"
               [class.overridden]="override"
               [(ngModel)]="row[field.reportedParam]"
               [maxLength]="(template.maxLength ? template.maxLength : 1000)"/>
    </div>
    @if (override) {
        <button type="button"
                class="ace-btn has-icon btn-primary btn-danger clear-override-button"
                title="Clear override value"
                (click)="classRef.clearValue(row, field)">
            <i class="fa fa-times"></i>
        </button>
    }
</ng-template>

<ng-template #number let-row="data" let-field="field" let-override="override">
    <div class="ws-flex-grow">
        <input type="number"
               autocomplete="off"
               class="form-control"
               [class.overridden]="override"
               [(ngModel)]="row[field.reportedParam]"
               maxLength="100"/>
    </div>
    @if (override) {
        <button type="button"
                class="ace-btn has-icon btn-primary btn-danger clear-override-button"
                title="Clear override value"
                (click)="classRef.clearValue(row, field)">
            <i class="fa fa-times"></i>
        </button>
    }
</ng-template>

<ng-template #currency
             let-row="data"
             let-field="field"
             let-override="override"
             let-adjustments="adjustments"
             let-isCalculated="isCalculated"
             let-classRef="classRef">
    <div style="width: 50%;">
        <ws-currency-input [override]="override"
                           [hasMargin]="false"
                           [hasAdjustments]="adjustments"
                           [isCalculated]="isCalculated"
                           [ngModel]="(field.reportedValueGetter) ? field.reportedValueGetter(row, field) : row[field.reportedParam]"
                           (ngModelChange)="row[field.reportedParam] = $event"
                           [disabled]="field.isDisabled && field.isDisabled()"
                           (valueChange)="classRef.templateValueChange($event, row, field)">
        </ws-currency-input>
    </div>
    @if (override) {
        <button type="button"
                class="ace-btn has-icon btn-primary btn-danger ms-1 my-0"
                title="Clear override value"
                (click)="classRef.clearValue(row, field)">
            <i class="fa fa-times"></i>
        </button>
    }
</ng-template>

<ng-template #date let-row="data" let-field="field" let-override="override" let-classRef="classRef">
    <div class="ws-flex-container-vertical">
        <div class="ws-flex-container-horizontal ws-flex-align-items-center">
            <div class="ws-flex-grow">
                <weissman-datetime class="ws-stretch-width"
                                   [dateOnly]="true"
                                   [inputDate]="(field.reportedValueGetter) ? field.reportedValueGetter(row, field) : row[field.reportedParam]"
                                   (inputDateChange)="classRef.templateValueChange($event, row, field)"
                                   [isDisabled]="field.isDisabled && field.isDisabled(row)"
                                   [isOverridden]="override">
                </weissman-datetime>
            </div>
            @if (override) {
                <button type="button"
                        class="ace-btn has-icon btn-primary btn-danger clear-override-button"
                        title="Clear override value"
                        (click)="classRef.clearValue(row, field)">
                    <i class="fa fa-times"></i>
                </button>
            }
        </div>
        @if (field.label === 'Disposed Date' && !classRef.createNewAsset) {
            <label>Do not potentially dispose
                <input type="checkbox" style="margin-left: 10px;" [(ngModel)]="row.reportedDoNotPotentiallyDispose"
                       (ngModelChange)="onDoNoPotentiallyDisposeChanged($event)" [disabled]="!row.isPrimary"></label>
        }
    </div>
</ng-template>

<ng-template #picklist let-row="data" let-field="field" let-override="override" let-template="template">
    <div class="ws-flex-grow">
        <ws-select labelProperty="name"
                   valueProperty="value"
                   class="ws-stretch-width"
                   [options]="field.picklist"
                   [(ngModel)]="row[(template.modelParam ? template.modelParam : field.reportedParam)]"
                   (selectedValueChanged)="classRef.templateValueChange($event, row, field)">
        </ws-select>
    </div>
    @if (override) {
        <button type="button"
                class="ace-btn has-icon btn-primary btn-danger clear-override-button"
                title="Clear override value"
                (click)="classRef.clearValue(row, field)">
            <i class="fa fa-times"></i>
        </button>
    }
</ng-template>

<ng-template #yesNo let-row="data" let-field="field" let-override="override" let-template="template">
    <div class="ws-flex-grow">
        <input type="checkbox"
               [class.overridden]="override"
               [ngModel]="row[field.reportedParam]"
               (ngModelChange)="classRef.templateValueChange($event, row, field)">
    </div>
    @if (override) {
        <button type="button"
                class="ace-btn has-icon btn-primary btn-danger clear-override-button"
                title="Clear override value"
                (click)="classRef.clearValue(row, field)">
            <i class="fa fa-times"></i>
        </button>
    }
</ng-template>

<!-- Custom Templates -->

<ng-template #acqDate let-row="data" let-field="field" let-override="override" let-classRef="classRef">
    <div class="ws-flex-container-vertical ws-stretch-width">
        <div class="ws-flex-grow">
            <weissman-datetime [dateOnly]="true"
                               [excludeValidation]="true"
                               [inputDate]="field.reportedValueGetter(row, field)"
                               (inputDateChange)="classRef.templateValueChange($event, row, field)"
                               [isDisabled]="field.isDisabled && field.isDisabled() || !row.isPrimary"
                               [isOverridden]="override">
            </weissman-datetime>
            @if (override) {
                <button type="button"
                        class="ace-btn has-icon btn-primary btn-danger clear-override-button"
                        title="Clear override value"
                        (click)="classRef.clearValue(row, field)">
                    <i class="fa fa-times"></i>
                </button>
            }
        </div>
        @if (classRef.allowPerpetual()) {
            <div class="ws-flex-container-horizontal ws-flex-none ws-flex-align-items-center acq-perpetual">
                <label class="ws-flex-none small ws-font-weight-normal">
                    <input type="checkbox"
                           name="isPerpetual"
                           [checked]="row.reportingIsPerpetual"
                           (change)="classRef.onIsPerpetualChanged($event.target, row)"
                           [disabled]="!classRef.editMode">
                    Perpetual
                </label>
                <i class="fa fa-info-circle"
                   title="When checked, the acquisition date will automatically assume an acquisition date at the end of the current reporting period relative to the lien date.  This will most often be used for reporting supplies or other assets which do not have entries coming directly from a client's fixed asset records."></i>
            </div>
        }
    </div>
</ng-template>

<ng-template #glAccount let-row="data" let-field="field" let-override="override" let-classRef="classRef">
    <gl-account-selector [companyId]="(row.reportedSite && row.reportedSite.companyID ? row.reportedSite.companyID : row.companyId)"
                         [isOverridden]="override"
                         [isRequiredField]="false"
                         [ngModel]="row.reportedGlAccount"
                         [glAccountName]="row[field.reportedParam]"
                         (glAccountChange)="classRef.onGlAccountSelected($event, row)">
    </gl-account-selector>
    @if (override) {
        <button type="button"
                class="ace-btn has-icon btn-primary btn-danger clear-override-button"
                title="Clear override value"
                (click)="classRef.clearValue(row, field)">
            <i class="fa fa-times"></i>
        </button>
    }
</ng-template>

<ng-template #assetClassification let-row="data" let-field="field" let-override="override" let-classRef="classRef">
    <asset-class-selector [isOverridden]="override"
                          [(assetClassificationId)]="row[field.reportedParam]"
                          (assetClassificationIdChange)="classRef.onAssetClassificationChanged($event, row)">
    </asset-class-selector>
    @if (override) {
        <button type="button"
                class="ace-btn has-icon btn-primary btn-danger clear-override-button"
                title="Clear override value"
                (click)="classRef.clearValue(row, field)">
            <i class="fa fa-times"></i>
        </button>
    }
</ng-template>

<ng-template #parcelSelector let-row="data" let-field="field" let-override="override" let-classRef="classRef">
    <parcel-selector [companyId]="row.companyId"
                     [(reportingParcelId)]="row[field.reportedParam]"
                     [siteIds]="[ row.reportedSite.siteID ]"
                     [masterSiteIds]="[ row.reportedSite.masterSiteId ]"
                     [isOverridden]="override"
                     [loadParcelsOnInit]="true"
                     [getParcels]="getParcels"
                     optionFlagText="Show only parcels under site"></parcel-selector>
    @if (override) {
        <button type="button"
                class="ace-btn has-icon btn-primary btn-danger clear-override-button"
                title="Clear override value"
                (click)="classRef.clearValue(row, field)">
            <i class="fa fa-times"></i>
        </button>
    }
</ng-template>

<ng-template #companiesSelector let-row="data" let-field="field" let-override="override" let-classRef="classRef">
    <select class="form-select form-select-sm"
            id="companyId"
            name="companyId"
            [(ngModel)]="classRef.selectedCompanyId"
            (ngModelChange)="classRef.updateSelectedCompanyId($event, row)">
        <option [ngValue]="classRef.topLevelCompanyId">{{ classRef.topLevelCompanyName }}</option>
        @if (classRef.childCompanies && classRef.childCompanies.length) {
            <optgroup label="Subsidiaries">
                @for (childCompany of classRef.childCompanies; track childCompany) {
                    <option [ngValue]="childCompany.id">
                        {{ childCompany.name }}
                    </option>
                }
            </optgroup>
        }
    </select>
    @if (override) {
        <button type="button"
                class="ace-btn has-icon btn-primary btn-danger clear-override-button"
                title="Clear override value"
                (click)="classRef.clearValue(row, field)">
            <i class="fa fa-times"></i>
        </button>
    }
</ng-template>

<ng-template #costAdjustments
             let-row="data"
             let-field="field"
             let-override="override"
             let-classRef="classRef"
             let-editMode="editMode">
    @if (editMode && !row.isLocked && row.isPrimary && classRef.showAssignByPercentageButton() && classRef.showCostAdjustments(field.descriptor.companyAssetDescriptorMappingId)) {
        <span
            [class.costMismatch]="!classRef.assetCostsMatchCalculatedTotals">
            <button type="button" class="ace-btn has-icon clear-override-button" helpTooltip
                    helpContentId="asset-info.allocate-cost-by-percentage" (click)="classRef.showCostPercentageModal()">
                <i class="fa fa-calculator fa-fw"></i>
            </button>
        </span>
    }
    @if (classRef.assets.length > 1 && !classRef.assetCostsMatchCalculatedTotals && !classRef.createNewAsset && (classRef.assetListForm && classRef.assetListForm.controls.costAssetDescriptors.value === field.descriptor.companyAssetDescriptorMappingId)) {
        <span class="percentageWarning"
              title="Source adjusted cost does not match allocated total of {{ classRef.allocatedTotal }}">
            <i class="fa fa-exclamation-circle"></i>
        </span>
    }
    @if (classRef.showCostAdjustments(field.descriptor.companyAssetDescriptorMappingId)) {
        @if (editMode && classRef.costAdjustmentControlsVisible) {
            <span class="float-end">
                {{ (field.sourceValueGetter) ? field.sourceValueGetter(row[field.reportedParam], field) : formatValue(row[field.sourceParam], field.reportedTemplate) }}
            </span>
        }
        @if (editMode && !row.isLocked) {
            <cost-adjustments
                [extendedCostAdjustmentTypes]="classRef.extendedCostAdjustmentTypes"
                [assetSummary]="row"
                [(costAdjustments)]="classRef.costAdjustments"
                [costCompanyAssetDescriptorMappingModel]="classRef.getCostCompanyAssetDescriptorMappingModel()"
                [costAdjustmentControlsVisible]="classRef.costAdjustmentControlsVisible"
                (costAdjustmentControlsVisibleChange)="classRef.setCostAdjustmentControlsVisible($event)"
                [assets]="classRef.assets">
            </cost-adjustments>
        }
        @if (!editMode) {
            <div class="cost-adjustment-description">{{ classRef.getCostAdjustmentDescription() }}</div>
        }
    }
</ng-template>

<ng-template #sites let-row="data" let-field="field" let-override="override" let-classRef="classRef">
    <div class="ws-flex-container-vertical">
        <div class="ws-flex-container-horizontal ws-flex-align-items-center">
            <site-selector [companyId]="((!classRef.createNewAsset) ? row.companyId : classRef.selectedCompanyId)"
                           [isOverridden]="override"
                           [siteName]="row[field.reportedParam]"
                           (siteChange)="classRef.onSiteSelected($event, row)">
            </site-selector>
            @if (override) {
                <button type="button"
                        class="ace-btn has-icon btn-primary btn-danger clear-override-button"
                        title="Clear override value"
                        (click)="classRef.clearValue(row, field)">
                    <i class="fa fa-times"></i>
                </button>
            }
        </div>
        @if (!classRef.createNewAsset) {
            <label>Is
                Anchored?<input type="checkbox" style="margin-left: 10px;" [(ngModel)]="row.reportedIsAnchored"></label>
        }
    </div>
</ng-template>

@if (currentAsset && !createNewAsset) {
    <div class="leasing-field-selector">
        <ul class="nav nav-tabs">
            <li class="uib-tab tab-item" [ngClass]="{ 'active' : selectedFieldsTab === AssetInfoFieldsTab.Asset }">
                <a class="nav-link" (click)="selectedFieldsTab = AssetInfoFieldsTab.Asset">Asset Fields</a></li>
            @if (currentAsset.isLeasedAsset) {
                <li class="uib-tab tab-item"
                    [ngClass]="{ 'active' : selectedFieldsTab === AssetInfoFieldsTab.Leasing }">
                    <a class="nav-link" (click)="selectedFieldsTab = AssetInfoFieldsTab.Leasing">Leasing Fields</a></li>
            }
            @if (showInventoryFields) {
                <li class="uib-tab tab-item"
                    [ngClass]="{ 'active' : selectedFieldsTab === AssetInfoFieldsTab.Inventory }">
                    <a class="nav-link" (click)="selectedFieldsTab = AssetInfoFieldsTab.Inventory">Inventory/Supply
                        Fields</a></li>
            }
        </ul>
    </div>
}
<div class="asset-info-holder">
    <form class="ws-stretch-width" #assetForm="ngForm">
        <div class="asset-detail-list"
             [ngClass]="{ 'asset-section-hidden' : selectedFieldsTab !== AssetInfoFieldsTab.Asset }"
             [formGroup]="assetListForm">
            @if (currentAsset) {
                <table>
                    <thead>
                        <tr class="detail-row">
                            <th class="header-cell sticky-col">Field</th>
                            <th class="header-cell sticky-col">
                                @if (currentAsset.hasImportedSource) {
                                    <span helpTooltip helpContentId="asset-info.source-column">Source Value</span>
                                }
                            </th>
                            @for (asset of assets; track asset; let i = $index) {
                                <th class="header-cell">
                                    <div class="ws-flex-container-horizontal ws-flex-align-items-center ws-flex-space-between">
                                        <span class="ws-flex-grow text-nowrap"
                                              helpTooltip
                                              helpContentId="asset-info.reporting-column">
                                            Reporting Value @if (assets.length > 1) {
                                            <span class="text-muted">(split {{ (i + 1) }} of {{ assets.length }})</span>
                                        }
                                        </span>
                                        <div class="split-controls">
                                            <div class="btn-group float-end ws-flex-container-horizontal" role="group">
                                                @if (editMode && !primaryAssetIsLocked && !createNewAsset && asset.hasImportedSource) {
                                                    <button type="button"
                                                            class="ace-btn btn-sm ace-btn btn-primary"
                                                            (click)="overrideAll(asset)"
                                                            helpTooltip
                                                            helpContentId="asset-info.override-all">
                                                        Override All
                                                    </button>
                                                }
                                                @if (editMode && !primaryAssetIsLocked && asset.isPrimary && !createNewAsset) {
                                                    <button type="button"
                                                            class="ace-btn btn-sm ace-btn btn-primary"
                                                            (click)="add()"
                                                            helpTooltip
                                                            helpContentId="asset-info.new-split">
                                                        New Split
                                                    </button>
                                                }
                                                @if (editMode && !asset.isPrimary) {
                                                    <button type="button"
                                                            class="ace-btn has-icon btn-sm ace-btn btn-primary btn-danger"
                                                            (click)="delete(asset)"
                                                            helpTooltip
                                                            helpContentId="asset-info.delete-split">
                                                        <i class="fa fa-trash"></i>
                                                    </button>
                                                }
                                                @if (!createNewAsset && canSeeHistory && !editMode) {
                                                    <button
                                                        title="History"
                                                        type="button"
                                                        class="ace-btn has-icon btn-sm ace-btn btn-primary"
                                                        (click)="viewHistory(asset)">
                                                        <i class="fa fa-history fa-align"></i>
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (field of assetListFields; track trackByFieldParam($index, field)) {
                            @if (!field.isRowShown || field.isRowShown()) {
                                <tr class="detail-row">
                                    <td class="detail-cell sticky-col"
                                        [attr.colspan]="(field.labelTemplate && field.labelTemplate.isDoubleWidth ? 2 : 1)">
                                        @if (editMode && !createNewAsset && field.descriptorList && field.descriptorCount) {
                                            <input
                                                type="radio"
                                                [formControlName]="field.descriptorList"
                                                [name]="field.descriptorList"
                                                [value]="field.descriptor.companyAssetDescriptorMappingId"
                                                helpTooltip
                                                [helpContentId]="field.descriptorHelpContentId"/>
                                        }
                                        <span helpTooltip
                                              [helpContentId]="field.labelHelpContentId">{{ field.label }}</span>
                                        @if (field.labelTemplate !== null && field.labelTemplate !== undefined) {
                                            <ng-container
                                                [ngTemplateOutlet]="getTemplate(field.labelTemplate)"
                                                [ngTemplateOutletContext]="{ data: currentAsset, field: field, override: null, template: field.labelTemplate, classRef: classRef, editMode: editMode }">
                                            </ng-container>
                                        }
                                    </td>
                                    @if (!field.sourceTemplate && (!field.isSourceCellShown || field.isSourceCellShown())) {
                                        <td class="detail-cell sticky-col">
                                            @if (currentAsset.hasImportedSource) {
                                                {{ (field.sourceValueGetter) ? field.sourceValueGetter(currentAsset[field.sourceParam], field) : formatValue(currentAsset[field.sourceParam], field.reportedTemplate) }}
                                            }
                                        </td>
                                    }
                                    @if (field.sourceTemplate && (!field.isSourceCellShown || field.isSourceCellShown())) {
                                        <td class="detail-cell sticky-col">
                                            @if (!editMode && currentAsset.hasImportedSource) {
                                                <div class="text-overflow">
                                                    <span>{{ (field.sourceValueGetter) ? field.sourceValueGetter(currentAsset[field.sourceParam], field) : formatValue(currentAsset[field.sourceParam], field.reportedTemplate) }}</span>
                                                </div>
                                            }
                                            @if (editMode && (!currentAsset.isLocked || field.reportedParam === 'reportedIsLocked') && field.sourceTemplate !== null && field.sourceTemplate !== undefined) {
                                                <ng-container
                                                    [ngTemplateOutlet]="getTemplate(field.sourceTemplate)"
                                                    [ngTemplateOutletContext]="{ data: currentAsset, field: field, override: null, template: field.sourceTemplate, classRef: classRef }">
                                                </ng-container>
                                            }
                                        </td>
                                    }
                                    @for (asset of assets; track trackByAssetId($index, asset)) {
                                        @if (!field.isReportedCellShown || field.isReportedCellShown()) {
                                            <td class="detail-cell reporting-cell" [ngClass]="field.cellClass">
                                                <div class="reported-cell-container">
                                                    @if (!editMode || (editMode && asset.isLocked && field.reportedParam !== 'reportedIsLocked') || (editMode && (!asset.isLocked || field.reportedParam === 'reportedIsLocked') && field.reportedTemplate && field.reportedTemplate.isStatic && field.reportedTemplate.isStatic())) {
                                                        <div class="text-overflow ws-flex-container-vertical">
                                                            <span [ngClass]="{ 'ws-calculated': asset[field.isCalculated], 'overridden': (field.descriptor && field.descriptor.columnName ? asset.reportedColumnHasOverride(field.descriptor.columnName) : asset[field.reportedOverride]), 'blank': asset[field.reportedOverrideWithBlank], 'has-adjustments': (field.descriptor && !(field.descriptor.columnName ? asset.reportedColumnHasOverride(field.descriptor.columnName) : asset[field.reportedOverride]) && isCostField(field.reportedTemplate.type) && hasCostAdjustments()) }">
                                                                {{ (field.reportedValueGetter) ? field.reportedValueGetter(asset, field) : formatValue(asset[field.reportedParam], field.reportedTemplate) }}
                                                            </span>
                                                            @if (field.label === 'Site') {
                                                                <span>{{ asset.reportedIsAnchored ? '' : 'Not' }}
                                                                    Anchored</span>
                                                            }
                                                            @if (field.label === 'Disposed Date' && asset.reportedDoNotPotentiallyDispose) {
                                                                <span>Do not potentially dispose</span>
                                                            }
                                                        </div>
                                                    }
                                                    @if (editMode && (!asset.isLocked || field.reportedParam === 'reportedIsLocked') && field.reportedTemplate && !(field.reportedTemplate.isStatic && field.reportedTemplate.isStatic())) {
                                                        <div class="split-controls ws-flex-container-horizontal ws-flex-align-items-center">
                                                            <ng-container [ngTemplateOutlet]="getTemplate(field.reportedTemplate)"
                                                                          [ngTemplateOutletContext]="{ data: asset, field: field, override: (field.descriptor && field.descriptor.columnName ? asset.reportedColumnHasOverride(field.descriptor.columnName) : asset[field.reportedOverride]), adjustments: hasCostAdjustments(), template: field.reportedTemplate, classRef: classRef }">
                                                            </ng-container>
                                                        </div>
                                                    }
                                                    @if (assetListForm.get(field.descriptorList) && assetListForm.get(field.descriptorList).value > 0 && assetListForm.get(field.descriptorList).value === field.descriptor.companyAssetDescriptorMappingId && (asset.reportedColumnHasOverride(field.descriptor.columnName) || asset[field.sourceParam])) {
                                                        <div class="alternate-cost-field-arrow"
                                                             [ngStyle]="{ 'top': arrowBounds[field.descriptorList].top + 'px', left: arrowBounds[field.descriptorList].left + 15 + 'px' }">
                                                            <svg helpTooltip
                                                                 [helpContentId]="arrowBounds[field.descriptorList].tooltip"
                                                                 [attr.height]="arrowBounds[field.descriptorList].height"
                                                                 [attr.width]="arrowBounds[field.descriptorList].width">
                                                                <path [attr.d]="arrowBounds[field.descriptorList].dPath"/>
                                                                <polygon [attr.points]="arrowBounds[field.descriptorList].arrowPoints"></polygon>
                                                            </svg>
                                                        </div>
                                                    }
                                                </div>
                                            </td>
                                        }
                                    }
                                </tr>
                            }
                        }
                    </tbody>
                </table>
            }
        </div>

        <div class="asset-detail-list"
             [ngClass]="{ 'asset-section-hidden' : selectedFieldsTab !== AssetInfoFieldsTab.Leasing }">
            @if (currentAsset && currentAsset.isLeasedAsset) {
                <table>
                    <thead>
                        <tr class="detail-row">
                            <th class="header-cell sticky-col">Field</th>
                            @if (currentAsset.hasImportedSource) {
                                <th class="header-cell sticky-col" helpTooltip
                                    helpContentId="asset-info.source-column">Source Value
                                </th>
                            }
                            @for (asset of assets; track asset; let i = $index) {
                                <th class="header-cell">
                                    <div class="ws-flex-container-horizontal ws-flex-align-items-center ws-flex-space-between">
                                        <span class="ws-flex-grow"
                                              helpTooltip
                                              helpContentId="asset-info.reporting-column">
                                            Reporting Value @if (assets.length > 1) {
                                            <span class="text-muted">(split {{ (i + 1) }} of {{ assets.length }})</span>
                                        }
                                        </span>
                                    </div>
                                </th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        <!-- LEASED TO OTHERS EXCLUSIVE FIELDS-->
                        @if (currentAsset && currentAsset.isLeasedToOther) {
                            @for (field of leasedToFields; track trackByFieldParam($index, field)) {
                                <tr class="detail-row">
                                    <td class="detail-cell sticky-col">{{ field.label }}</td>
                                    @if (currentAsset.hasImportedSource) {
                                        <td class="detail-cell sticky-col">{{ formatValue(currentAsset[field.sourceParam], field.reportedTemplate) }}</td>
                                    }
                                    @for (asset of assets; track trackByAssetId($index, asset)) {
                                        <td class="detail-cell reporting-cell">
                                            @if (!editMode || currentAsset.isLocked) {
                                                <div class="text-overflow">
                                                    <span [ngClass]="{ 'overridden': asset[field.reportedOverride] }">
                                                        {{ formatValue(asset[field.reportedParam], field.reportedTemplate) }}
                                                    </span>
                                                </div>
                                            }
                                            @if (editMode && field.reportedTemplate && !currentAsset.isLocked) {
                                                <div class="split-controls ws-flex-container-horizontal ws-flex-align-items-center">
                                                    <ng-container [ngTemplateOutlet]="getTemplate(field.reportedTemplate)"
                                                                  [ngTemplateOutletContext]="{ data: asset, field: field, override: asset[field.reportedOverride], template: field.reportedTemplate, classRef: classRef }"></ng-container>
                                                </div>
                                            }
                                        </td>
                                    }
                                </tr>
                            }
                        }
                        <!-- LEASED TO OR FROM OTHERS FIELDS-->
                        @if (currentAsset && currentAsset.isLeasedAsset) {
                            @for (field of leasedToFromFields; track trackByFieldParam($index, field)) {
                                <tr class="detail-row">
                                    <td class="detail-cell sticky-col">{{ field.label }}</td>
                                    @if (currentAsset.hasImportedSource) {
                                        <td class="detail-cell sticky-col">{{ formatValue(currentAsset[field.sourceParam], field.reportedTemplate) }}</td>
                                    }
                                    @for (asset of assets; track trackByAssetId($index, asset)) {
                                        <td class="detail-cell reporting-cell">
                                            @if (!editMode || currentAsset.isLocked) {
                                                <div class="text-overflow">
                                                    <span [ngClass]="{ 'overridden': asset[field.reportedOverride] }">
                                                        {{ formatValue(asset[field.reportedParam], field.reportedTemplate) }}
                                                    </span>
                                                </div>
                                            }
                                            @if (editMode && field.reportedTemplate && !currentAsset.isLocked) {
                                                <div class="split-controls ws-flex-container-horizontal ws-flex-align-items-center">
                                                    <ng-container [ngTemplateOutlet]="getTemplate(field.reportedTemplate)"
                                                                  [ngTemplateOutletContext]="{ data: asset, field: field, override: asset[field.reportedOverride], template: field.reportedTemplate, classRef: classRef }"></ng-container>
                                                </div>
                                            }
                                        </td>
                                    }
                                </tr>
                            }
                        }
                    </tbody>
                </table>
            }

        </div>

        <div class="asset-detail-list"
             [ngClass]="{ 'asset-section-hidden' : selectedFieldsTab !== AssetInfoFieldsTab.Inventory }">
            @if (currentAsset && selectedFieldsTab === AssetInfoFieldsTab.Inventory) {
                <table>
                    <thead>
                        <tr class="detail-row">
                            <th class="header-cell sticky-col">Field</th>
                            @if (currentAsset.hasImportedSource) {
                                <th class="header-cell sticky-col" helpTooltip
                                    helpContentId="asset-info.source-column">Source Value
                                </th>
                            }
                            @for (asset of assets; track asset; let i = $index) {
                                <th class="header-cell">
                                    <div class="ws-flex-container-horizontal ws-flex-align-items-center ws-flex-space-between">
                                        <span class="ws-flex-grow"
                                              helpTooltip
                                              helpContentId="asset-info.reporting-column">
                                            Reporting Value @if (assets.length > 1) {
                                            <span class="text-muted">(split {{ (i + 1) }} of {{ assets.length }})</span>
                                        }
                                        </span>
                                    </div>
                                </th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (field of inventoryFields; track trackByFieldParam($index, field)) {
                            <tr class="detail-row">
                                <td class="detail-cell sticky-col">{{ field.label }}</td>
                                @if (currentAsset.hasImportedSource) {
                                    <td class="detail-cell sticky-col">{{ formatValue(currentAsset[field.sourceParam], field.reportedTemplate) }}</td>
                                }
                                @for (asset of assets; track trackByAssetId($index, asset)) {
                                    <td class="detail-cell reporting-cell">
                                        @if (!editMode || currentAsset.isLocked) {
                                            <div class="cost text-overflow">
                                                <span [ngClass]="{ 'overridden': asset[field.reportedOverride], 'ws-calculated': asset[field.isCalculated] }">
                                                    {{ formatValue(asset[field.reportedParam], field.reportedTemplate) }}
                                                </span>
                                            </div>
                                        }
                                        @if (editMode && field.reportedTemplate && !currentAsset.isLocked) {
                                            <div class="split-controls ws-flex-container-horizontal ws-flex-align-items-center">
                                                <ng-container [ngTemplateOutlet]="getTemplate(field.reportedTemplate)"
                                                              [ngTemplateOutletContext]="{ data: asset, field: field, override: asset[field.reportedOverride], isCalculated: asset[field.isCalculated], template: field.reportedTemplate, classRef: classRef }"></ng-container>
                                            </div>
                                        }
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
            }
        </div>

    </form>
</div>
